export interface PageTypeDocumentationConfig {
    pageTypes?: Record<string, { name?: string }>
}

export interface PageDocumentationSource {
    pageTypeId?: string | number
    pageType?: string
}

export function getPageTypeDocumentationLink(
    field: string,
    page: PageDocumentationSource,
    config?: PageTypeDocumentationConfig,
): string {
    const pageType = config?.pageTypes?.[String(page.pageTypeId)]?.name || page.pageType
    return pageType ? `${field}-${pageType.toLowerCase()}` : field
}